<template>
  <div>
    <div v-if="true">
      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_53d3b8626252"
        path="pages/index/index"
        @launch="handleLaunch"
        @error="handleError"
      >
        <script type="text/wxtag-template">
          <slot></slot>
        </script>
      </wx-open-launch-weapp>
    </div>
    <div v-else @click="handleClick">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { isWeixinBrowser } from '@/utils';
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';
export default {
  props: {
    businessType: {
      type: Number,
      require: true
    }
  },
  computed: {
    isInWeixinBrowser() {
      return isWeixinBrowser();
    },
    isXl() {
      return this.businessType === 8;
    }
  },
  methods: {
    handleClick() {
      useCoupon(this.businessType);
      this.$emit('click');
    },
    handleLaunch() {
      console.log('launch success');
    },
    handleError(e) {
      console.log('launch fail');
      console.log(e.detail);
    }
  }
};
</script>
